<app-button
  type="filled"
  [loading]="loading||!product_priced_attr_value"
  (onClick)="add()"
  >Add to Cart</app-button
>
